module.exports = __webpack_public_path__ + "static/media/augr.7e0bfa9d.jpg";